import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/context/ThemeContext";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

export default function PageHeader({ title, subtitle }: PageHeaderProps) {
  const { t } = useTranslation("home");
  const { effectiveTheme } = useTheme();
  const isLight = effectiveTheme === "light";

  return (
    <div
      className={`relative border-b ${
        isLight
          ? "bg-[#f5f5f7] border-b border-black/5"
          : "bg-cosmic-950 border-b border-white/5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="flex items-center justify-between py-5">
          {/* Back to home */}
          <Link
            to="/"
            className={`flex items-center gap-1.5 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isLight
                ? "text-[#6e6e73] hover:text-[#1c1c1e]"
                : "text-silver-500 hover:text-white"
            }`}
          >
            <i className="ri-arrow-left-s-line text-lg" />
            <span>{t("nav.back_home")}</span>
          </Link>

          {/* Center title */}
          <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center">
            <motion.h1
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className={`text-lg sm:text-xl font-bold ${
                isLight ? "text-[#1c1c1e]" : "text-white"
              }`}
            >
              {title}
            </motion.h1>
            {subtitle && (
              <span
                className={`text-xs mt-0.5 hidden sm:block ${
                  isLight ? "text-[#6e6e73]" : "text-silver-500"
                }`}
              >
                {subtitle}
              </span>
            )}
          </div>

          {/* Placeholder for balance */}
          <div className="w-20" />
        </div>
      </div>
    </div>
  );
}